import API from '@/services/endpoint'
import { FETCH_GALLERY_LIST} from "../../mutation-types";

/**
 * API Get Request to fetch the gallery images
 * @param {function} commit - The vuex commit function
 * @param {object} state - The vuex state object
 * @return {object[]} A array of images
 */
export async function fetchGallery({commit, state}) {
  const { url } = state;
  let responseObj = await API.get(url);
  let { data: { message: { images } } } = responseObj;
  commit(FETCH_GALLERY_LIST, images)
}
